export default __webpack_public_path__ + "static/media/bathroom.2aa5337e.svg";